'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _distanceBetweenPoints = require('@danmmx/distance-between-points');

var _distanceBetweenPoints2 = _interopRequireDefault(_distanceBetweenPoints);

var _Point = require('./Point');

var _Point2 = _interopRequireDefault(_Point);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Gradient = function () {
  function Gradient(_ref) {
    var initial = _ref.initial,
        end = _ref.end,
        width = _ref.width,
        height = _ref.height,
        jumps = _ref.jumps;

    _classCallCheck(this, Gradient);

    this.jumps = jumps;
    this.cache = {};

    var widthInTriangles = Math.ceil(width / jumps);
    var heightInTriangles = Math.ceil(height / jumps);
    var radial = Math.round(Math.sqrt(widthInTriangles * widthInTriangles + heightInTriangles * heightInTriangles));

    var colors = [];
    var i = void 0;

    this.center = new _Point2.default(widthInTriangles / 2, heightInTriangles / 2 - 1.5);

    // If there are more colors than triangles
    if (radial / 2 + 1 < end - initial) {
      while (radial / 2 + 1 < end - initial) {
        end--;
        if (radial / 2 + 1 < end - initial) {
          initial++;
        }
      }

      for (i = initial; i < end; i++) {
        colors.push(i);
      }
      // there are more triangles than colors
    } else {
      for (i = initial; i < end; i++) {
        colors.push(i);
      }

      while (colors.length < Math.ceil(radial / 2)) {
        colors.push(colors[Math.floor(Math.random() * 8)]);
      }
    }
    colors.sort(function (a, b) {
      return a - b;
    }).reverse();

    this.colors = colors;
  }

  _createClass(Gradient, [{
    key: 'randomGray',
    value: function randomGray(x, y) {
      var jumps = this.jumps,
          center = this.center,
          colors = this.colors,
          cache = this.cache;


      var spaceX = x / jumps;
      var spaceY = y / jumps;
      var distFromCenter = cache[x] && cache[x][y] || Math.floor((0, _distanceBetweenPoints2.default)(center, new _Point2.default(spaceX, spaceY)));
      var color = colors[distFromCenter] || colors[colors.length + 1];
      var random = 0;

      if (!cache[x]) {
        cache[x] = {};
      }

      if (!cache[x][y]) {
        cache[x][y] = distFromCenter;
      }

      if (distFromCenter > colors.length * 0.7) {
        random = Math.ceil(Math.random() * 2) * (Math.random() < 0.5 ? -1 : 1) * 1;
      } else if (distFromCenter > colors.length * 0.6) {
        random = Math.ceil(Math.random() * 2) * (Math.random() < 0.5 ? -1 : 1) * 2;
      } else if (distFromCenter > colors.length * 0.4) {
        random = Math.ceil(Math.random() * 2) * (Math.random() < 0.5 ? -1 : 1) * 3;
      } else if (distFromCenter > colors.length * 0.2) {
        random = Math.ceil(Math.random() * 2) * (Math.random() < 0.5 ? -1 : 1) * 2;
      } else {
        random = Math.ceil(Math.random() * 2) * (Math.random() < 0.5 ? -1 : 1) * 1;
      }

      color += random;

      return 'rgb(' + [color, color, color].join(',') + ')';
    }
  }, {
    key: 'setCenter',
    value: function setCenter(x, y) {
      this.center = new _Point2.default(x / this.jumps, y / this.jumps);
      this.cache = {};
    }
  }]);

  return Gradient;
}();

exports.default = Gradient;


//////////////////
// WEBPACK FOOTER
// ./~/triangles-canvas/dist/Gradient.js
// module id = 435
// module chunks = 35783957827783